import { UserInfo } from '@/Admin/UserInfo'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/userManager/$userId')({
  component: RouteComponent,
})

function RouteComponent() {
  return <UserInfo />
}
